const getDataServers = config => () => {
  return config.dataServers;
};

export default getDataServers;
